<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <v-form
          v-model="valid"
          lazy-validation
        >
          <v-card class="login_form type2 type3" flat>
            <h2 class="logo mb-25 d-flex" style="justify-content: space-between; max-width:100%;">
              <div>
                <v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img>
              </div>
              <div class="lang__selector ty2">
                <v-switch
                  v-model="rtl"
                  color="red"
                  value="red"
                  class=""
                  hide-details
                  @change="fnSetLocale()"
                ></v-switch>
                <v-spacer class="hidden_lr5"></v-spacer>
                <span v-if="rtl">{{ $t('common.common.arabic') }}</span>
                <span v-else>{{ $t('common.common.english') }}</span>
              </div>
            </h2>
            <h3 class="out_title mb-15">{{ $t('signup.title') }}</h3>
            <h4 class="out_subtitle mb-35">{{ $t('signup.common.regist.company.sub_title') }}</h4>

            <!-- Account -->
            <h2 class="login_f_title mt-25">{{ $t('signup.common.regist.company.fields.account') }}</h2>
            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-25">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.email') }}</h2>
                  <h3 class="inner_title type2">{{ email }}</h3>
                </v-col>

                <v-card
                  flat
                  class="foot__info type2 mb-40"
                >
                  <v-card-text class="pa-0">
                    <h2>{{ $t('signup.common.regist.company.fields.password_rule_title') }}</h2>
                    <div class="d-flex">
                      <v-spacer class="hidden_lr22 d-inline-block"></v-spacer>
                      <p class="d-inline-block">{{ $t('signup.common.regist.company.fields.password_rule_1') }}</p>
                    </div>
                    <div class="d-flex">
                      <v-spacer class="hidden_lr22 d-inline-block"></v-spacer>
                      <p class="d-inline-block">{{ $t('signup.common.regist.company.fields.password_rule_2') }}</p>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Password -->
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.password') }}</h2>
                  <v-text-field
                    label=""
                    v-model="password"
                    v-validate="{required: true, password_rule: true}"
                    :error-messages="errors.collect('password')"
                    name="password"
                    data-vv-as="Password"
                    append-icon="mdi-alert"
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    type="password"
                    class="login_text_filed"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.password_re') }}</h2>
                  <v-text-field
                      label=""
                      v-model="password_re"
                      v-validate="{required: true, password_match: true}"
                      :error-messages="errors.collect('password_re')"
                      name="password_re"
                      data-vv-as="Re-enter Password"
                      append-icon="mdi-alert"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      type="password"
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>

              </v-row>
            </v-card-text>

            <h2 class="login_f_title">{{ $t('signup.common.regist.company.fields.personal_information') }}</h2>
            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.english_name') }}</h2>
                  <v-text-field
                      label=""
                      v-model="name_en"
                      v-validate="{required: true}"
                      :error-messages="errors.collect('english_name')"
                      name="english_name"
                      :data-vv-as="$t('signup.common.regist.company.fields.english_name')"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      :placeholder="$t('signup.common.regist.company.fields.english_name')"
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.arabic_name') }}</h2>
                  <v-text-field
                      label=""
                      v-model="name_ar"
                      v-validate="{required: true}"
                      :error-messages="errors.collect('arabic_name')"
                      name="arabic_name"
                      :data-vv-as="$t('signup.common.regist.company.fields.arabic_name')"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      :placeholder="$t('signup.common.regist.company.fields.arabic_name')"
                      class="login_text_filed arabic_align"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.birth') }}</h2>

                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label=""
                        v-model="birthday_date"
                        v-validate="{required: true}"
                        :error-messages="errors.collect('birthday_date')"
                        name="birthday_date"
                        data-vv-as="Birth"
                        placeholder="DD-MM-YYYY format"
                        v-bind="attrs"
                        v-on="on"
                        solo
                        outlined
                        flat
                        dense
                        append-icon="mdi-alert"
                        class="login_text_filed"
                        readonly
                        @click:append="menu = true"
                    ></v-text-field>
                    </template>
                    <v-date-picker :max="today" v-model="date" no-title @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.gender') }}</h2>
                  <v-select
                    :items="$vuetify.rtl ? genderListAr : genderListEn"
                    v-model="gender_type_code"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('gender')"
                    name="gender"
                    data-vv-as="Gender"
                    solo
                    flat
                    outlined
                    dense
                    class="select_h40 login_select_box bdr_none"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.nationality') }}</h2>
                  <v-select
                    v-model="nationality_code"
                    :items="$vuetify.rtl ? countryArList : countryEnList"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('nationality')"
                    name="nationality"
                    data-vv-as="Nationality"
                    solo
                    flat
                    outlined
                    dense
                    class="select_h40 login_select_box bdr_none"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <h2 class="login_f_title type2">{{ $t('signup.common.regist.company.fields.contact_no') }}</h2>
            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.telephone') }}</h2>
                  <v-text-field
                    label=""
                    v-model="telephone"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('telephone')"
                    name="telephone"
                    data-vv-as="Telephone"
                    maxlength="64"
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    append-icon="mdi-alert"
                    placeholder=""
                    class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15">{{ $t('signup.common.regist.company.fields.mobile_phone') }}</h2>
                  <v-text-field
                      label=""
                      v-model="mobile"
                      maxlength="64"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      placeholder=""
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15">{{ $t('signup.common.regist.company.fields.facsimile_no') }}</h2>
                  <v-text-field
                      label=""
                      v-model="fax"
                      maxlength="64"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      placeholder=""
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <h2 class="login_f_title type2">{{ $t('signup.common.regist.company.fields.proof_of_identity') }}</h2>
            <v-card-text class="pa-0 inner_item_content pa-0 mb-50">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.employer_data') }}</h2>
                  <div class="file_inpt fileForm">
                    <v-file-input
                      accept=".pdf, .jpg, .gif"
                      outlined
                      flat
                      dense
                      :placeholder="(id_card_file_name) ? id_card_file_name : $t('common.common.no_files_selected')"
                      :prepend-icon="$t('common.common.select_file')"
                      class="login_text_filed"
                      v-model="idCardFile"
                      v-validate="{required: id_card_file_key === '', file_rule: true}"
                      :error-messages="errors.collect('idCardFile')"
                      name="idCardFile"
                      data-vv-as="ID Card, Passport or Company Registration File"
                      @change="fnUploadIdCardFile()"
                      clearable
                      @click:clear="fnInitIdCardFile()"
                      :append-icon="id_card_file_name ? '$clear': ''"
                      @click:append="fnInitIdCardFile()"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>


            <h2 class="login_f_title">{{ $t('signup.common.regist.company.fields.company_information') }}</h2>
            <v-card-text class="pa-0 inner_item_content" v-if="!company.company_regiration_no_old">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-15">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.agent.email.fields.company_regist_no') }}</h2>
                  <v-text-field
                    label=""
                    :placeholder="$t('signup.agent.email.fields.company_regist_no')"
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    name="company_regiration_no"
                    v-validate="{required: isNewCompany}"
                    v-model="company.company_regiration_no"
                    :error-messages="errors.collect('company_regiration_no')"
                    :data-vv-as="$t('signup.agent.email.fields.company_regist_no')"
                    append-icon="mdi-alert"
                    class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <h2 class="login_f_title type2">{{ $t('signup.common.regist.company.fields.company_name') }}</h2>
            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.english_name') }}</h2>
                  <v-text-field
                    label=""
                    v-model="company.name_en"
                    v-validate="{required: isNewCompany}"
                    :error-messages="errors.collect('company_name_en')"
                    name="company_name_en"
                    :data-vv-as="$t('signup.common.regist.company.fields.english_name')"
                    :disabled="disabled"
                    solo
                    outlined
                    flat
                    dense
                    clearable
                    append-icon="mdi-alert"
                    :placeholder="$t('signup.common.regist.company.fields.english_name')"
                    class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.arabic_name') }}</h2>
                  <v-text-field
                      label=""
                      v-model="company.name_ar"
                      v-validate="{required: isNewCompany}"
                      :error-messages="errors.collect('company_name_ar')"
                      name="company_name_ar"
                      :data-vv-as="$t('signup.common.regist.company.fields.arabic_name')"
                      :disabled="disabled"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      :placeholder="$t('signup.common.regist.company.fields.arabic_name')"
                      class="login_text_filed arabic_align"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <h2 class="login_f_title type2">{{ $t('signup.common.regist.company.fields.address') }}</h2>
            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-60">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.english_address') }}</h2>

                  <v-row class="ma-0 mb-20" v-show="isNewCompany">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.street') }}</h2>
                      <v-text-field
                        label=""
                        v-model="company.address_en"
                        v-validate="{required: isNewCompany}"
                        :error-messages="errors.collect('address_en')"
                        name="address_en"
                        data-vv-as="Street address"
                        :disabled="disabled"
                        solo
                        outlined
                        flat
                        dense
                        clearable
                        placeholder=""
                        append-icon="mdi-alert"
                        class="login_text_filed"
                    ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 mb-20" v-show="!isNewCompany">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.street') }}</h2>
                      <v-text-field
                        label=""
                        v-model="company.address_en"
                        disabled
                        solo
                        outlined
                        flat
                        dense
                        clearable
                        placeholder=""
                        append-icon="mdi-alert"
                        class="login_text_filed"
                    ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.city') }}</h2>
                      <v-text-field
                        label=""
                        v-model="company.city_name_en"
                        v-validate="{required: isNewCompany}"
                        :error-messages="errors.collect('city_name_en')"
                        name="city_name_en"
                        data-vv-as="City"
                        :disabled="disabled"
                        solo
                        outlined
                        flat
                        dense
                        clearable
                        placeholder=""
                        append-icon="mdi-alert"
                        class="login_text_filed"
                    ></v-text-field>
                    </v-col>
                    <v-spacer class="hidden_lr5"></v-spacer>
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.country') }}</h2>
                      <v-select
                        :items="countryEnList"
                        v-model="company.residence_country_code"
                        v-validate="{required: isNewCompany}"
                        :error-messages="errors.collect('residence_country_code_en')"
                        name="residence_country_code_en"
                        data-vv-as="Country"
                        :disabled="disabled"
                        solo
                        flat
                        outlined
                        dense
                        class="select_h40 login_select_box bdr_none"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="pa-0 mb-60">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.arabic_address') }}</h2>
                  <v-row class="ma-0 mb-20" v-show="isNewCompany">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.street') }}</h2>
                      <v-text-field
                        label=""
                        v-model="company.address_ar"
                        v-validate="{required: isNewCompany}"
                        :error-messages="errors.collect('address_ar')"
                        name="address_ar"
                        data-vv-as="Street address"
                        :disabled="disabled"
                        solo
                        outlined
                        flat
                        dense
                        clearable
                        placeholder=""
                        append-icon="mdi-alert"
                        class="login_text_filed arabic_align"
                    ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 mb-20" v-show="!isNewCompany">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.street') }}</h2>
                      <v-text-field
                        label=""
                        v-model="company.address_ar"
                        disabled
                        solo
                        outlined
                        flat
                        dense
                        clearable
                        placeholder=""
                        append-icon="mdi-alert"
                        class="login_text_filed arabic_align"
                    ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.city') }}</h2>
                      <v-text-field
                        label=""
                        v-model="company.city_name_ar"
                        v-validate="{required: isNewCompany}"
                        :error-messages="errors.collect('city_name_ar')"
                        name="city_name_ar"
                        data-vv-as="City"
                        :disabled="disabled"
                        solo
                        outlined
                        flat
                        dense
                        clearable
                        placeholder=""
                        append-icon="mdi-alert"
                        class="login_text_filed arabic_align"
                    ></v-text-field>
                    </v-col>
                    <v-spacer class="hidden_lr5"></v-spacer>
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.common.regist.company.fields.country') }}</h2>
                      <v-select
                        :items="countryArList"
                        v-model="company.residence_country_code"
                        v-validate="{required: isNewCompany}"
                        :error-messages="errors.collect('residence_country_code_ar')"
                        name="residence_country_code_ar"
                        data-vv-as="Country"
                        :disabled="disabled"
                        solo
                        flat
                        outlined
                        dense
                        :reverse="$vuetify.rtl? false : true"
                        class="select_h40 login_select_box bdr_none arabic_align"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15">{{ $t('signup.common.regist.company.fields.pobox') }}</h2>
                  <v-row class="ma-0 mb-20">
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.agent.regist.fields.pobox_en') }}</h2>
                      <v-text-field
                          label=""
                          v-model="company.pobox_en"
                          name="pobox_en"
                          data-vv-as="P.O.Box"
                          solo
                          outlined
                          flat
                          dense
                          clearable
                          append-icon="mdi-alert"
                          class="login_text_filed"
                      ></v-text-field>
                    </v-col>
                    <v-spacer class="hidden_lr5"></v-spacer>
                    <v-col class="pa-0">
                      <h2 class="italic_title mb--10">{{ $t('signup.agent.regist.fields.pobox_ar') }}</h2>
                      <v-text-field
                          label=""
                          v-model="company.pobox_ar"
                          name="pobox_ar"
                          data-vv-as="P.O.Box"
                          solo
                          outlined
                          flat
                          dense
                          clearable
                          append-icon="mdi-alert"
                          class="login_text_filed arabic_align"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15">{{ $t('signup.common.regist.company.fields.postal_code') }}</h2>
                  <v-text-field
                      label=""
                      v-model="company.postal"
                      name="postal_code"
                      data-vv-as="Postal Code"
                      :disabled="disabled"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      class="login_text_filed"
                      maxlength="16"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <h2 class="login_f_title type2">{{ $t('signup.common.regist.company.fields.contact_no') }}</h2>
            <v-card-text class="pa-0 inner_item_content">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.telephone') }}</h2>
                  <v-text-field
                      label=""
                      v-model="company.telephone"
                      v-validate="{required: true}"
                      :error-messages="errors.collect('company_telephone')"
                      name="company_telephone"
                      data-vv-as="company_telephone"
                      :disabled="disabled"
                      maxlength="64"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      placeholder=""
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15">{{ $t('signup.common.regist.company.fields.mobile_phone') }}</h2>
                  <v-text-field
                      label=""
                      v-model="company.mobile"
                      maxlength="64"
                      solo
                      outlined
                      flat
                      dense
                      :disabled="disabled"
                      clearable
                      append-icon="mdi-alert"
                      placeholder=""
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15">{{ $t('signup.common.regist.company.fields.facsimile_no') }}</h2>
                  <v-text-field
                      label=""
                      v-model="company.fax"
                      maxlength="64"
                      solo
                      outlined
                      flat
                      dense
                      :disabled="disabled"
                      clearable
                      append-icon="mdi-alert"
                      placeholder=""
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <h2 class="login_f_title type2">{{ $t('signup.common.regist.company.fields.proof_of_identity') }}</h2>
            <v-card-text class="pa-0 inner_item_content pa-0 mb-30">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.commercial_registry_certification') }}</h2>
                  <div class="file_inpt fileForm">
                    <v-file-input
                      accept=".pdf, .jpg, .gif"
                      outlined
                      dense
                      :placeholder="(company.registry_cert_file_name) ? company.registry_cert_file_name : $t('common.common.no_files_selected')"
                      :prepend-icon="$t('common.common.select_file')"
                      class="login_text_filed"
                      v-model="registryCertFile"
                      v-validate="{required: isNewCompany && company.registry_cert_file_key == '', file_rule: isNewCompany}"
                      :error-messages="errors.collect('registryCertFile')"
                      name="registryCertFile"
                      data-vv-as="Registry Certification File"
                      :disabled="disabled"
                      @change="fnUploadCertFile()"
                      clearable
                      @click:clear="fnInitCertFile()"
                      :append-icon="company.registry_cert_file_name ? '$clear': ''"
                      @click:append="fnInitCertFile()"
                    >
                    </v-file-input>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>


            <h2 class="login_f_title">{{ $t('signup.common.regist.company.fields.method_title') }}</h2>
            <v-card-text class="pa-0 inner_item_content mb-50">
              <v-row class="ma-0">
                <!-- E-mail -->
                <v-col cols="12" class="pa-0">
                  <h3 class="alert_text_title pb--10">{{ $t('signup.agent.regist.fields.select_method_notice') }}</h3>
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.method_desc') }}</h2>
                  <v-select
                    hide-details
                    :items="$vuetify.rtl ? methodListAr : methodListEn"
                    v-model="strong_auth_type_code"
                    solo
                    flat
                    outlined
                    dense
                    class="select_h40 login_select_box bdr_none"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <!-- Google OTP -->
            <h2 class="login_f_title" v-show="strong_auth_type_code == '3703'">{{ $t('signup.common.regist.company.fields.google_otp') }}</h2>
            <v-card-text class="pa-0 inner_item_content mb-50" v-show="strong_auth_type_code == '3703'">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0 mb-30">
                  <h3 class="alert_text_title pb--10">{{ $t('signup.agent.regist.fields.google_otp_notice') }}</h3>
                  <div class="otp_box">
                    <v-img :src="qrcode_url"></v-img>
                  </div>
                </v-col>

                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.google_otp_desc') }}</h2>
                  <v-text-field
                      label=""
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      type="password"
                      class="login_text_filed"
                      v-model="otp_code"
                      v-validate="{required: valid_google, pincode_rule: valid_google}"
                      :error-messages="errors.collect('otp_code')"
                      name="otp_code"
                      :data-vv-as="$t('signup.common.regist.company.fields.google_otp_desc')"
                      maxlength="6"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <!-- PIN Code -->
            <h2 class="login_f_title" v-show="strong_auth_type_code == '3702'">{{ $t('signup.common.regist.company.fields.pin_code') }}</h2>
            <v-card-text class="pa-0 inner_item_content mb-50" v-show="strong_auth_type_code == '3702'">
              <v-row class="ma-0">
                <h3 class="alert_text_title pb--10">{{ $t('signup.agent.regist.fields.pin_code_notice') }}</h3>

                <v-col cols="12" class="pa-0 mb-35">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.pin_code') }}</h2>
                  <v-text-field
                      label=""
                      v-model="registered_pin_code"
                      v-validate="{required: valid_pincode, pincode_rule: valid_pincode}"
                      :error-messages="errors.collect('registered_pin_code')"
                      name="registered_pin_code"
                      data-vv-as="PIN Code"
                      maxlength="6"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      type="password"
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="pa-0">
                  <h2 class="nec_title mb-15"><i>*</i> {{ $t('signup.common.regist.company.fields.pin_code_re') }}</h2>
                  <v-text-field
                      label=""
                      v-model="registered_pin_code_re"
                      v-validate="{required: valid_pincode, pincode_match: valid_pincode}"
                      :error-messages="errors.collect('registered_pin_code_re')"
                      name="registered_pin_code_re"
                      data-vv-as="Re-enter PIN Code"
                      maxlength="6"
                      solo
                      outlined
                      flat
                      dense
                      clearable
                      append-icon="mdi-alert"
                      type="password"
                      class="login_text_filed"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-row class="ma-0 btn_wrap pb-50">
              <v-btn class="sign_in_btn type2 colorwh" text @click="fnSignup()">{{ $t('signup.common.regist.company.fields.sign_up') }}</v-btn>
            </v-row>
          </v-card>

        </v-form>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import store from '@/store'
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import en from 'vee-validate/dist/locale/en'
import ar from 'vee-validate/dist/locale/ar'

export default {
  name: 'CommonCompanyRegist',
  components: {
  },
  data () {
    return {

      methodListAr : [],
      methodListEn: [],
      genderListAr: [],
      genderListEn: [],
			countryEnList: [],
      countryArList: [],
      menu: false,
      today: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),

      valid :true,
      valid_google : false,
      valid_pincode : false,

      user_seq : '',
      email: '',
      password : '',
      password_re : '',
      name_en : '',
      name_ar : '',
      birthday_date : '',
      gender_type_code : '',
      nationality_code : 'EG',
      user_type_code : '',
      strong_auth_type_code : '',
      registered_pin_code : '',
      registered_pin_code_re : '',
      id_card_file_key : '',
      id_card_file_name: '',
      telephone : '',
      mobile : '',
      fax : '',
      company : {
        company_regiration_no : '',
        company_regiration_no_old: '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        city_name_ar : '',
        city_name_en : '',
        residence_country_code : 'EG',
        pobox_en : '',
        pobox_ar : '',
        postal : '',
        telephone : '',
        mobile : '',
        fax : '',
        registry_cert_file_name: '',
        registry_cert_file_key : ''
      },

      idCardFile : null,
      registryCertFile : null,
      pinCodeNotMatche : true,

      isNewCompany : true,
      disabled : false,

      //Google Otp 관련
      qrcode_url : '',
      encode_key : '',
      otp_code : '',
    }
  },
  created () {
    if (store.state.api.language === 'en') {
      this.$vuetify.rtl = false
      this.rtl = null
      this.$i18n.locale = 'en'
      this.$vuetify.lang.current = 'en'
      this.$validator.localize('en', en)
    } else if (store.state.api.language === 'ar') {
      this.$vuetify.rtl = true
      this.rtl = 'red'
      this.$i18n.locale = 'ar'
      this.$vuetify.lang.current = 'ar'
      this.$validator.localize('ar', ar)
    }
    let validator = this.$validator

    this.$validator.extend('password_rule',{
      getMessage: field => field+' is not meet the required security level',
      validate: value => {
        //소문자 대문자 숫자 (8,32)
        let check_1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,32}/.test(value)

        //소문자 대문자 특수문자 (8,32)
        let check_2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=])[A-Za-z!@#$%^&+=]{8,32}/.test(value)

        //소문자 숫자 특수문자 (8,32)
        let check_3 = /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&+=])[a-z\d!@#$%^&+=]{8,32}/.test(value)

        //대문자 숫자 특수문자 (8,32)
        let check_4 = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=])[A-Z\d!@#$%^&+=]{8,32}/.test(value)

        //소문자 대문자 숫자 특수문자(8,32)
        let check_5 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=])[A-Za-z\d!@#$%^&+=]{8,32}/.test(value)

        let result = false
        if(check_1 || check_2 || check_3 || check_4 || check_5){
          result = true
        }

        return result
      }
    })

    this.$validator.extend('password_match', {
      getMessage: field => field+' is not matched',
      validate: value => {

        let target = validator.fields.find({name: 'password'})

        return value == target.value

      }
    })

    this.$validator.extend('pincode_rule',{
      getMessage: field => field+' must be 6 Decimal digit numbers',
      validate: value => {
        //숫자(6)
        let check = /^\d{6}$/.test(value)

        if(check){
          this.pinCodeNotMatche = false
        }else{
          this.pinCodeNotMatche = true
        }

        return check
      }
    })

    this.$validator.extend('pincode_match', {
      getMessage: field => field+' is not matched',
      validate: value => {

        let target = validator.fields.find({name: 'registered_pin_code'})

        return value == target.value

      }
    })

    this.$validator.extend('file_rule', {
      getMessage: field => field+' size should be less than 20 MB!',
      validate: value => {

        let result = true

        if(value.size > 1024 * 1024 * 20){
          result = false
        }

        return result
      }
    })

  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnInit()
  },
  watch: {
    password() {
      this.$validator.validate('password_re')
    },
    registered_pin_code() {
      this.$validator.validate('registered_pin_code_re')
    },
    date () {
      this.birthday_date = this.formatDate(this.date)
    },
    strong_auth_type_code() {
      if(this.strong_auth_type_code == '3702'){
        this.valid_google = false
        this.valid_pincode = true
      }else if(this.strong_auth_type_code == '3703'){
        this.valid_google = true
        this.valid_pincode = false
      }else if(this.strong_auth_type_code == '3704'){
        this.valid_google = false
        this.valid_pincode = false
      }
    }
  },
  methods: {
    fnInit() {
      //url에서 마지막 단을 코드값으로 담아두자
      let codeParamArr = window.location.href.split("/")
      let code = codeParamArr[codeParamArr.length - 1]

      //추출한 코드가 유효한 값인지 확인 하고 유효 하지 않을 경우 돌려보낸다
      requestApi({
        url: '/autho/verify/account/'+code,
        method: 'GET',
        callback: (res) => {
          //코드 체크 결과 플래그
          let isSuccess = false
          if(res.res_code == '200'){
            //3602 = Sign up
            if('3602' == res.data.email_verify_type_code){
              isSuccess = true

              this.email = res.data.user_email
              this.company.company_regiration_no = res.data.company_regiration_no
              this.company.company_regiration_no_old = res.data.company_regiration_no
              this.user_type_code = res.data.user_type_code

              //user_seq 가 있는 경우는 반려 당한 후 재수정 하러 온 케이스 이므로 기 입력 했던 정보를 다시 입력 해 두어야 한다.
              if(res.data.user_seq){
                this.user_seq = res.data.user_seq

                this.company.name_ar = res.data.company.name_ar
                this.company.name_en = res.data.company.name_en
                this.company.address_ar = res.data.company.address_ar
                this.company.address_en = res.data.company.address_en
                this.company.city_name_ar = res.data.company.city_name_ar
                this.company.city_name_en = res.data.company.city_name_en
                this.company.residence_country_code = res.data.company.residence_country_code
                this.company.pobox_en = res.data.company.pobox_en
                this.company.pobox_ar = res.data.company.pobox_ar
                this.company.postal = res.data.company.postal
                this.company.telephone = res.data.company.telephone
                this.company.mobile = res.data.company.mobile
                this.company.fax = res.data.company.fax
                this.company.registry_cert_file_name = res.data.company.registry_cert_file_name
                this.company.registry_cert_file_key = res.data.company.registry_cert_file_key

                this.strong_auth_type_code = res.data.user.strong_auth_type_code
                this.registered_pin_code = res.data.user.registered_pin_code
                this.registered_pin_code_re = res.data.user.registered_pin_code
                this.name_en = res.data.user.name_en
                this.name_ar = res.data.user.name_ar
                this.birthday_date = res.data.user.birthday_date
                this.gender_type_code = res.data.user.gender_type_code
                this.nationality_code = res.data.user.nationality_code
                this.id_card_file_key = res.data.user.id_card_file_key
                this.id_card_file_name = res.data.user.id_card_file_name
                this.telephone = res.data.user.telephone
                this.mobile = res.data.user.mobile
                this.fax = res.data.user.fax
              }else{
                requestApi({
                  url: '/common/users/company/'+this.company.company_regiration_no,
                  method: 'GET',
                  callback: (res) => {
                    if(res.data){
                      this.company.name_ar = res.data.name_ar
                      this.company.name_en = res.data.name_en
                      this.company.address_ar = res.data.address_ar
                      this.company.address_en = res.data.address_en
                      this.company.city_name_ar = res.data.city_name_ar
                      this.company.city_name_en = res.data.city_name_en
                      this.company.residence_country_code = res.data.residence_country_code
                      this.company.pobox_ar = res.data.pobox_ar
                      this.company.pobox_en = res.data.pobox_en
                      this.company.postal = res.data.postal
                      this.company.telephone = res.data.telephone
                      this.company.mobile = res.data.mobile
                      this.company.fax = res.data.fax
                      this.company.registry_cert_file_name = res.data.registry_cert_file_name
                      this.company.registry_cert_file_key = res.data.registry_cert_file_key

                      this.disabled = true
                      this.isNewCompany = false
                    }
                  }
                })
              }

              this.fnGetcountryEnList()
              this.fnGetGenderList()
              this.fnGetTwoFactorMethodList()
              this.fnGetQrCode()
            }
          }

          //이메일 코드 확인 결과 실패일 경우
          if(!isSuccess){
            this.$router.push({ path : '/signup/common/registFail/'+code})
          }
        }
      })
    },

    fnSetLocale () {
      if (this.$vuetify.rtl) {
        this.rtl = null
        this.$vuetify.rtl = false
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
        store.dispatch('SetLanguage', 'en')
      } else {
        this.rtl = 'red'
        this.$vuetify.rtl = true
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
        store.dispatch('SetLanguage', 'ar')
      }
    },

    fnGetQrCode(){
      //Google OTP QR Code URL및 인증키
      let params = {
        email : this.email
      }

      requestApi({
        url: '/autho/googleotp/qrcode',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.qrcode_url = res.data.qrcode_url
            this.encode_key = res.data.encode_key
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    },

    fnGetcountryEnList() {
      //국가 정보를 가져온다
      utils.fnGetCountryList('en').then(list => {
        this.countryEnList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList('ar').then(list => {
        this.countryArList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })
    },

    fnGetGenderList() {
      let options = {
        upper_code: '4000'
      }
      utils.fnGetCodeList(options).then(list => {
        this.genderListAr = list.ar
        this.genderListEn = list.en
        if(utils.isNull(this.gender_type_code)){
          this.gender_type_code = this.genderListAr[0].value
        }
      })
    },

    fnGetTwoFactorMethodList() {
      let options = {
        upper_code: '3700',
        remove: [
          {code: '3701'}
        ]
      }
      utils.fnGetCodeList(options).then(list => {
        this.methodListAr = list.ar
        this.methodListEn = list.en
        if(utils.isNull(this.strong_auth_type_code)){
          this.strong_auth_type_code = this.methodListAr[0].value
        }
      })
    },

    fnInitCertFile() {
      this.registryCertFile = null
      this.company.registry_cert_file_key = ''
      this.company.registry_cert_file_name = ''
    },

    fnUploadCertFile(){
      let certFile = this.registryCertFile

      if(certFile != null){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.registryCertFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.registryCertFile = null
            this.company.registry_cert_file_key = ''
            this.company.registry_cert_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", certFile)

        requestApi({
          url: '/file/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.company.registry_cert_file_key = res.data.file_key
            }else{
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.registryCertFile = null
              this.company.registry_cert_file_key = ''
              this.company.registry_cert_file_name = ''
            }
          }
        })
      }
    },
    fnInitIdCardFile() {
      this.idCardFile = null
      this.id_card_file_key = ''
      this.id_card_file_name = ''
    },

    fnUploadIdCardFile(){
      let idCardFile = this.idCardFile

      if(idCardFile != null){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.idCardFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.idCardFile = null
            this.id_card_file_key = ''
            this.id_card_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", idCardFile)

        requestApi({
          url: '/file/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            // 파일저장
            if (res.res_code === '200') {
              this.id_card_file_key = res.data.file_key
            }else{
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.idCardFile = null
              this.id_card_file_key = ''
              this.id_card_file_name = ''
            }
          }
        })
      }
    },

    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },

    fnSignup(){
      this.$validator.validateAll().then((result) => {
        if(result){
          //회원등록 실행
          this.fnSignupRegist()

        }else{
          //2020-10-09 : 첫번째 에러 항목으로 Focus 되도록 추가 수정
          try{
            let errorFieldName = this.$validator.errors.items[0].field;
            window.document.getElementsByName(errorFieldName)[0].focus()
          }catch(ex){
            console.log('[validatorAll] No Find Element')
          }
        }
      })
    },

    fnSignupRegist() {
      //업로드 완료후 회원등록 처리
      let company_info= {
        company_regiration_no: this.company.company_regiration_no,
        company_regiration_no_old: this.company.company_regiration_no,
        name_ar: this.company.name_ar,
        name_en: this.company.name_en,
        address_ar: this.company.address_ar,
        address_en: this.company.address_en,
        city_name_ar: this.company.city_name_ar,
        city_name_en: this.company.city_name_en,
        residence_country_code: this.company.residence_country_code,
        pobox_en: this.company.pobox_en,
        pobox_ar: this.company.pobox_ar,
        postal: this.company.postal,
        telephone: this.company.telephone,
        mobile: this.company.mobile,
        fax: this.company.fax,
        registry_cert_file_key: this.company.registry_cert_file_key
      }

      //2차 로그인 인증방법
      if(this.strong_auth_type_code == '3703'){
        //Google OTP
        this.registered_pin_code = this.encode_key
      }else if(this.strong_auth_type_code == '3702'){
        //PIN CODE 이라면
        this.otp_code = ''
      }else{
        this.registered_pin_code = ''
        this.otp_code = ''
      }

      let params = {
        user_seq: this.user_seq,
        email: this.email,
        password: this.password,
        name_en: this.name_en,
        name_ar: this.name_ar,
        birthday_date: this.birthday_date,
        gender_type_code: this.gender_type_code,
        nationality_code: this.nationality_code,
        user_type_code: this.user_type_code,
        strong_auth_type_code: this.strong_auth_type_code,
        registered_pin_code: this.registered_pin_code,
        otp_code : this.otp_code,
        id_card_file_key: this.id_card_file_key,
        telephone : this.telephone,
        mobile : this.mobile,
        fax : this.fax,
        agent_no : '',
        agent_type_code: '',
        company: company_info
      }

      requestApi({
        url: '/autho/users/companies',
        method: 'POST',
        data: params,
        callback: (res) => {

          if (res.res_code === '200') {
            this.$router.push('/signup/common/registSuccess')
          }else{
            this.registered_pin_code = ''
            this.otp_code = ''

            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    }

  }

}
</script>

<style lang="less">
</style>
